// extracted by mini-css-extract-plugin
export default {"Thankyou":"Footer_Thankyou__AGqcp","myanimation":"Footer_myanimation__KpYCj"};